import { useGetEntities } from '@abaninja/util-store';

import { getDocumentPaymentMethods } from '../documents';

export const useDocumentPaymentMethodStore = () => useGetEntities(getDocumentPaymentMethods);
